<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Misi</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-md-5">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="changePeriode($event)" v-model="filter_rpjmd" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>
                </div>
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success text-center kepala_table_f">
                            <!-- <th class="text-center" style="width: 5%">No.</th> -->
                            <th class="text-center" style="width: 5%">No</th>
                            <th class="text-center" style="width: 40%">Uraian Misi</th>
                            <th class="text-center" style="width: 40">Keterangan</th>
                            <th class="text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="9" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="(data) in list_misi" :key="data.misi_id">
                                    <!-- <td class="text-center tabel_center">1.</td> -->
                                    <td class="text-center tabel_center">{{data.no_misi}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="text-justify tabel_center">{{data.keterangan}}</td>

                                    <td class="text-center tabel_center" >
                                        <button  @click="view_misi_dengan_isu_strategis(data.misi_id)" class="btn bg-light-blue btn-xs waves-effect" title="Pilih Isu Strategis" data-toggle="modal" data-target="#m_pilih_isu_strategis">
                                            <i class="material-icons" >link</i>
                                        </button>
                                            &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.misi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                      <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">
                                <div class="modal-body">

    
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Periode RPJMD</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="data.rpjmd_id">
                                                        <option v-for="dla in list_rpjmd" :key="dla.rpjmd_id" :value="dla.rpjmd_id">{{dla.periode}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nomor Misi</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                <input type="number" class="form-control" v-model="data.no_misi">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian misi</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="data.uraian" rows="4" class="form-control no-resize" placeholder="Masukan Uraian..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Periode RPJMD</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <select class="form-control" v-model="rpjmd_id">
                                                        <option v-for="dla in list_rpjmd" :key="dla.rpjmd_id" :value="dla.rpjmd_id">{{dla.periode}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Nomor Misi</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input type="number" class="form-control" v-model="no_misi">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian misi</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="uraian" rows="4" class="form-control no-resize" placeholder="Masukan Uraian..." :required="true"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_pilih_isu_strategis" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">KETERKAITAN DENGAN ISU STRATEGIS</h4>
                                </div>
                                <div class="modal-body">
                                    <button @click="btn_pilih_isu_strategis" data-toggle="modal" data-target="#m_list_isu_strategis" class="btn bg-light-blue btn-xs waves-effect">Tambah data</button>
                                    <hr>
                                    
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No Isu</th>
                                                    <th class="text-center" style="width: 75%">Uraian Isu</th>
                                                    <th class="text-center" style="width: 15%">Pilih</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="(data) in list_misi_dengan_isu_strategis" :key="data.relasi_id">
                                                    <td class="text-center">{{data.no_isu_strategis}}</td>
                                                    <td >{{data.uraian_isu_strategis}}</td>
                                                    <td class="text-center">
                                                        <button @click="remove_misi_dengan_isu_strategis(data)" class="btn bg-red btn-xs waves-effect" title="Hapus Data">
                                                            <i class="material-icons" >clear</i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                                <div class="modal-footer">

                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_list_isu_strategis" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">PILIH LIST ISU STRATEGIS</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No Isu</th>
                                                    <th class="text-center" style="width: 75%">Uraian Isu</th>
                                                    <th class="text-center" style="width: 15%">Pilih</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="(data) in list_isu_strategis" :key="data.isu_strategis_id">
                                                    <td class="text-center">{{data.no_isu_strategis}}</td>
                                                    <td >{{data.uraian}}</td>
                                                    <td class="text-center">
                                                        <input type="checkbox" :id="data.isu_strategis_id" :value="data.isu_strategis_id" v-model="pilih_isu_strategis" class="filled-in chk-col-light-blue">
                                                        <label :for="data.isu_strategis_id"></label>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="add_misi_dengan_isu_strategis" type="button" class="btn btn-info waves-effect" >SIMPAN</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_ISU_STRATEGIS = URL_APP+'api/v1/isu_strategis/';


    export default {
        name: "planning_urusan",
        data() {
          return {
              data:{
                  misi_id: '',
                  rpjmd_id: '',
                  no_misi: '',
                  uraian: '',
                  keterangan: ''
              },
              uraian: '',
              no_misi: '',
              keterangan: '',
              misi_id: '',
              rpjmd_id: '',
              select_rpjmd_edit : '',
              list_misi: [],
              filter_rpjmd: "",
              list_rpjmd: [],
              pilih_isu_strategis: [],
              list_isu_strategis : [],
              list_misi_dengan_isu_strategis :[],
              page_first : 1,
              page_last : 0,
              cari_value : '',
              cek_load_data : true,
          };
        },

        mounted() {
            this.getData();
            this.getDataRPJMD();
            localStorage.sidemenu = 'planing';
            
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            changePeriode: function(ev){
                this.filterPeriodeFunction(this.filter_rpjmd);
            },

            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readData', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                    this.list_rpjmd = data_rpjmd.data;
                    // this.page_last = data_visi.jml_data;
                })
            },

            filterPeriodeFunction: function(id){
                if(id == ''){
                    this.getData();
                }else{
                fetch(ADD_URL+'getData', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        id: id
                    })
                }).then((res) => res.json()).then((data_misi) => {
                    this.list_misi = data_misi.data;
                    this.page_last = data_misi.jml_data;
                })
                }
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_misi) => {
                  this.list_misi = data_misi.data;
                  this.page_last = data_misi.jml_data;
                  this.cek_load_data = false;
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        misi_id : this.misi_id,
                        no_misi : this.no_misi,
                        rpjmd_id : this.rpjmd_id,
                        uraian : this.uraian,
                        keterangan : this.keterangan
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.changePeriode('nope');
                    // this.getData();
                });
            },
            selectData : function(data){
                this.misi_id = data.misi_id;
                this.no_misi = data.no_misi;
                this.rpjmd_id = data.rpjmd_id;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.data.rpjmd_id = data.rpjmd_id;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.changePeriode('nope');
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                  misi_id: '',
                  rpjmd_id: '',
                  no_misi: '',
                  uraian: '',
                  keterangan: ''
                };
                this.misi_id= '';
                this.rpjmd_id= '';
                this.no_misi= '';
                this.uraian= '';
                this.keterangan= '';
                this.list_isu_strategis = [];
                this.pilih_isu_strategis =[];
            },

            getIsuStrategis: function(){
                fetch(ADD_URL_ISU_STRATEGIS, {
                    method : 'GET',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },

                }).then((res)=> res.json()).then((res_data) => {
                    
                    var list_misi_isu_strategis = this.list_misi_dengan_isu_strategis

                    for (let j = 0; j < list_misi_isu_strategis.length; j++) {
                        const element = list_misi_isu_strategis[j].isu_strategis_id;
                        
                        for( var i = 0; i < res_data.length; i++){ 
                            if ( res_data[i].isu_strategis_id == element) {
                                res_data.splice(i, 1); 
                            }
                        }


                    }
                    this.list_isu_strategis = res_data;

                    // console.log(this.list_misi_dengan_isu_strategis);

                })
            },
            btn_pilih_isu_strategis : function(){
                this.getIsuStrategis();
            },
            view_misi_dengan_isu_strategis : function(data){
                this.misi_id = data;
                fetch(ADD_URL+'view_misi_dengan_isu_strategis', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      misi_id : this.misi_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_misi_dengan_isu_strategis = res_data;
                //   console.log(this.list_misi_dengan_isu_strategis);
                })
            },

            add_misi_dengan_isu_strategis : function(){

                fetch(ADD_URL+'add_misi_dengan_isu_strategis', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        isu_strategis_id : this.pilih_isu_strategis,
                        misi_id : this.misi_id,
                    })
                }).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.view_misi_dengan_isu_strategis(this.misi_id);
                });
                // console.log(this.pilih_isu_strategis);
            },
            remove_misi_dengan_isu_strategis : function(data){

                fetch(ADD_URL+'remove_misi_dengan_isu_strategis', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        relasi_id : data.relasi_id,
                    })
                }).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menghapus Data!');
                    this.view_misi_dengan_isu_strategis(this.misi_id);
                });
                console.log(this.misi_id);
                this.view_misi_dengan_isu_strategis(this.misi_id);
            },

            //PAGINASI
                alertku : function(type, title){
                    this.$swal({
                        type: type,
                        title: title,
                        showConfirmButton: false,
                        timer: 800
                    });
                },

                btn_prev : function(){
                    this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getData();
                },

                btn_next : function(){
                    this.cek_load_data = true;
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getData();
                },

                cari_data : function(){
                    this.cek_load_data = true;
                    this.page_first = 1;
                    this.getData();
                }
            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
